export const FETCH_METERS_START = 'FETCH_METERS_START'
export const FETCH_METERS_SUCCESS = 'FETCH_METERS_SUCCESS'
export const FETCH_METERS_ERROR = 'FETCH_METERS_ERROR'

export const FETCH_READINGS_SUCCESS = 'FETCH_READINGS_SUCCESS'
export const FETCH_READINGS_ERROR = 'FETCH_READINGS_ERROR'

export const FETCH_REPO_START = 'FETCH_REPO_START'
export const FETCH_REPO_SUCCESS = 'FETCH_REPO_SUCCESS'
export const FETCH_REPO_README_SUCCESS = 'FETCH_REPO_README_SUCCESS'
export const FETCH_REPO_FIRST_COMMITS_SUCCESS = 'FETCH_REPO_FIRST_COMMITS_SUCCESS'
export const FETCH_REPO_ERROR = 'FETCH_REPO_ERROR'

export const FETCH_LOGIN_START = 'FETCH_LOGIN_START'
export const FETCH_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS'
export const FETCH_LOGIN_ERROR = 'FETCH_LOGIN_ERROR'

export const FETCH_LOGOUT = 'FETCH_LOGOUT'
